export default __webpack_public_path__ + "static/media/banner-login.297d93b2.png";